<template>
  <!-- copy Link Dialog -->
  <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="$t('cos.copy_link_with_expires')"
    :default-cancel="false" @close="closeDialog" :width="520">
    <ul class="item-descr-list allow-user-select">

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.file_name')}}</label>
        </span>
        <span class="item-descr-txt">
          <span>{{shareLinkInfo.name}}</span>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>{{$t("cos.public_permission")}}</label>
        </span>
        <span class="item-descr-txt">
          <qc-icon v-if="shareLinkInfo.acl==='loading'" type="loading"></qc-icon>
          <span v-else>{{shareLinkInfo.acl | ObjectAclText}}</span>
        </span>
      </li>

      <!-- <li>
        <span class="item-descr-tit">
          <label>{{$t('cos.specified_domain')}}
            <qc-bubble type="dark" :append-to-body="false">
              <qc-icon type="plaint"></qc-icon>
              <template slot="popup">{{$t("cos.tips.specified_domain")}}</template>
            </qc-bubble>
          </label>
        </span>
        <span class="item-descr-txt">
          <domain-select v-model="domain" :bucket="bucketInfo.Bucket" :region="bucketInfo.Region"></domain-select>
        </span>
      </li> -->

      <li>
        <span class="item-descr-tit">
          <label>{{$t('core.link_type')}}</label>
        </span>
        <span class="item-descr-txt">
          <div class="mb-10">
            <qc-radio value="unSign" v-model="type" @input="onChange" :title="$t('cos.copy_link_without_sign')"
              class="mb-10">
              {{$t("cos.copy_link_without_sign")}}
            </qc-radio>
          </div>
          <div>
            <qc-radio value="sign" v-model="type" @input="onChange" :title="$t('cos.copy_link_with_sign')">
              {{$t("cos.copy_link_with_sign")}}
            </qc-radio>
          </div>
          <div v-if="type === 'sign'" style="margin:10px 0 0 20px;">
            <div class="form-unit" :class="{'is-error':durationStatus.isError}">
              <div class="tc-15-input-text-wrap">
                <input class="tc-15-input-text m" v-model="duration" style="width:80px;" @keyup="durationValidate"
                  @input="onChange" />
                <select class="tc-15-select m" v-model="unit" style="width:70px;min-width:70px;border-left:0;"
                  @change="onChange">
                  <option v-for="(unitLabel, unitKey) in unitMap" :value="unitKey" :key="unitKey"
                    :selected="unit===unitKey">
                    {{unitLabel}}
                  </option>
                </select>
                  <div class="form-input-help">{{$t(`cos.validate.${durationStatus.message}`)}}</div>
                  <div class="tc-15-msg warning" style="margin-right: 30px">
                    <div class="tip-info">
                        <div v-html="$t('cos.shareInfo')"></div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>URL</label>
        </span>
        <span class="item-descr-txt">
          <qc-icon v-if="shareLinkInfo.acl==='loading'" type="loading"></qc-icon>
          <qc-input v-else type="textarea" v-model="objectUrl" :rows="6" :readonly="true"
            style="line-height:16px;background-color:unset;padding:8px;"></qc-input>
        </span>
      </li>
    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button :disabled="durationStatus.isError" type="default" @click="doShareLink" :title="$t('core.copy')">
            {{$t('core.copy')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps, copyLink2Clipboard } from '@/scripts/tools/utils';
import cos from '@/scripts/helper/cos';
import cosPure from '@/scripts/helper/cos/cosPure';
import keyBox from '@/scripts/helper/keyBox';

// import domainSelect from '@/components//dialog/file/fileInfo/domainSelect';

const unitBase = {
  min: 60,
  h: 60 * 60,
  d: 60 * 60 * 24,
};

export default {
  components: {
    // domainSelect,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    shareLinkInfo: {
      type: Object,
      required: true,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 复制链接
      type: 'sign',
      duration: 2,
      durationError: false,
      durationStatus: {
        isError: false,
        message: 'need_positive_int',
      },
      unit: 'h',
      unitMap: {
        min: window.lang.t('core.time_unit.min'),
        h: window.lang.t('core.time_unit.h'),
        d: window.lang.t('core.time_unit.d'),
      },
      domain: '',
      objectUrl: '',
      keyType: '',
    };
  },
  watch: {
    shareLinkInfo(val) {
      // 表示非快速复制链接（即弹窗打开）
      if (val.tag !== 'fastCopy' && val.acl !== 'loading') {
        this.type = this.shareLinkInfo.type;
        this.onChange();
      }
    },
    domain(val, old) {
      if (old) {
        this.onChange();
      }
    },
    show() {
      this.initData();
    },
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  methods: {
    initData() {
      this.keyType = keyBox.getKeyType();
      if (this.keyType !== 'SecretKey') {
        this.durationStatus.message = 'share_valid_time[2]';
        delete this.unitMap.d;
      }
    },
    // 复制链接间隔输入校验
    durationValidate() {
      const { duration, unit } = this;
      let isError = false;
      let message = '';
      if (this.keyType === 'QcloudAccount') {
        message = 'share_valid_time[2]';
      } else {
        message = 'need_positive_int';
      }

      // oauth 登录的账号临时链接的有效时间只有 2 小时
      const oauthExpireLimit = 2 * unitBase.h;
      const oauthExpiredTime = parseInt(unitBase[unit] * duration, 10);
      if (!duration) {
        isError = true;
        message = 'empty_input_content';
      } else if (+duration <= 0 || Number.isNaN(+duration)) {
        isError = true;
        message = 'need_positive_number';
      } else if (!/^(\d+)\.?(\d)?$/.test(duration)) {
        isError = true;
        message = 'only_allow_one_decimal';
      } else if (this.keyType === 'QcloudAccount' && oauthExpiredTime > oauthExpireLimit) {
        isError = true;
      }
      this.durationStatus = { isError, message };
    },
    async getObjectUrl(item) {
      let url = '';

      if (item && item.tag === 'fastCopy') {
        this.duration = 2;
        this.unit = 'h';
        ({ url } = item);
      } else {
        ({ url } = this.shareLinkInfo);
      }
      const { Bucket, Region } = this.bucketInfo;
      const domain = cos.getDefaultBucketDomain({ Bucket, Region });

      let baseUrl = '';
      let tempUrl = '';
      // 若非默认源站域名
      if (this.domain && this.domain !== domain) {
        const Key = item && item.tag === 'fastCopy' ? item.key : this.shareLinkInfo.key;
        cosPure.options.Domain = this.domain;
        cosPure.options.Protocol = cos.options.Protocol;
        baseUrl = cosPure.getObjectUrl({ Bucket, Region, Key });
      } else {
        baseUrl = url;
      }

      if (this.type === 'unSign') {
        return baseUrl;
      }

      let Expires;
      const { duration, unit } = this;
      if (duration) {
        Expires = parseInt(unitBase[unit] * duration, 10);
      }
      Expires = Expires || 1800;
      tempUrl = await cos.getDownloadUrl(baseUrl, false, Expires);

      return tempUrl;
    },
    async onChange() {
      this.objectUrl = await this.getObjectUrl();
    },
    async doShareLink(item) {
      // 父组件传值调用
      if (item.tag === 'fastCopy') {
        // eslint-disable-next-line prefer-destructuring
        this.type = item.type;
        this.objectUrl = await this.getObjectUrl(item);
      }

      const { type, objectUrl } = this;
      if (type === 'unSign') {
        copyLink2Clipboard({ link: objectUrl });
      } else {
        const { duration, unit } = this;
        copyLink2Clipboard({
          link: objectUrl,
          isPrivate: true,
          duration,
          unit,
        });
      }
      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>
